import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import { environment } from '../../../environments/environment';
import { AuthenticationService } from "../../views/authentication/authentication.service";


@Injectable()
export class SearchLineService {

  constructor(private http: HttpClient,  private authService: AuthenticationService) {
  }

  getHeaders(): HttpHeaders {
    let headers: HttpHeaders = new HttpHeaders();
    headers = headers.append('Authorization', 'Bearer ' + this.authService.token);
    return headers;
  }

  search(num: any) : Observable<any>  {

    return this.http.post(environment.HR + '/hr/search-line-owner/',num, { headers: this.getHeaders() })
  }

}



// WEBPACK FOOTER //
// ./src/app/components/app-search-line/app-search-line.service.ts